// 整站内容模型（默认值 / 兜底）。后台会把它存进 server/data/content.json 并可编辑。
const defaultContent = {
  site: {
    brandName: '加太教育',
    brandEn: 'JIATAI EDU',
    productBrand: '少年造物局',
    company: '上海加太教育科技有限公司',
    phone: '400-888-0000',
    email: 'hello@touchcode.edu',
    address: '中国 · 创新科技园',
    hours: '周一至周日 9:00 - 21:00',
    icp: '',
    police: '',
    footerNote: '本网站为演示项目 · 品牌名称、备案号与机构信息均为占位示例，上线前请替换为真实信息',
  },

  home: {
    slides: [
      {
        id: 1, image: '/images/site/classroom-wide.jpg', link: '/news/science-museum-course', gradient: ['#1e3a8a', '#2563eb'],
        eyebrow: '机构课程包 · 科创硬件', title: '把能展示的项目\n带进信息课',
        subtitle: '面向学校、科技馆、少年宫及培训机构，提供青少年编程与机器人课程包、硬件套件和落地支持。',
        ctaText: '获取合作方案', ctaLink: '/contact', altText: '看看有哪些课', altLink: '/courses',
      },
      {
        id: 2, image: '/images/site/morse-kit-source.png', link: '/news/morse-code-course', gradient: ['#3730a3', '#7c3aed'],
        eyebrow: '摩斯电码课程包', title: '按住屏幕\n打出第一段密码',
        subtitle: '短按是点、长按是划，配套硬件、课件与教案，支持机构快速组织项目式课堂。',
        ctaText: '了解课程', ctaLink: '/courses', altText: '机构咨询', altLink: '/contact',
      },
      {
        id: 3, image: '/images/site/competition-awards.jpg', link: '/news/ball-balance-system', gradient: ['#065f46', '#059669'],
        eyebrow: '学校合作', title: '把课程包与硬件套件\n交付给机构',
        subtitle: '硬件、课程包、师资培训与技术支持一体化，帮助学校和机构稳定落地科创项目课。',
        ctaText: '索取合作方案', ctaLink: '/schools', altText: '联系我们', altLink: '/contact',
      },
    ],
    services: {
      eyebrow: '产品与服务',
      title: '我们提供什么',
      desc: '软硬件一体，从设备、课件、教案到机构落地支持，让科创课程包更容易交付和实施。',
      items: [
        { icon: 'Cpu', title: '自研硬件设备', desc: '基于 STM32 的电阻屏开发板，软硬件一体、稳定可离线，适合机构批量部署和课堂演示。', link: '/about' },
        { icon: 'BookOpen', title: '项目式课程包', desc: '从摩斯电码到涂鸦、小球平衡，提供由浅入深的课程包、课件教案和示例程序。', link: '/courses' },
        { icon: 'Building2', title: '校园整体方案', desc: '面向学校与机构，提供设备、课程包、师资培训和交付支持，帮助信息课和社团稳定落地。', link: '/schools' },
      ],
    },
    proof: {
      eyebrow: "课堂现场",
      title: "从真实项目走进真实课堂",
      desc: "课程包围绕摩斯电码、电阻屏交互与板球平衡等项目展开，支持机构组织搭建、调试和展示。",
      items: [
        {
          src: "/images/site/classroom-wide.jpg",
          title: "机构落地场景",
          desc: "项目台、硬件套件与课程流程支持机构组织课堂实施。"
        },
        {
          src: "/images/site/morse-kit-source.png",
          title: "摩斯电码课程",
          desc: "从触摸输入、点划编码到屏幕反馈，形成可交付的项目式课程内容。"
        },
        {
          src: "/images/site/ball-balance-device.jpg",
          title: "板球平衡系统",
          desc: "完整装置展示机械结构、舵机控制和反馈调节的基本逻辑。"
        }
      ]
    },
    advantages: {
      eyebrow: '核心优势',
      title: '学校和机构为什么选少年造物局',
      items: [
        { icon: 'Hand', title: '手指就是输入', desc: '动手为主、屏幕为辅，不用键盘也能玩，减少久坐盯屏。' },
        { icon: 'WifiOff', title: '完全离线', desc: '离线部署，不依赖外网，减少网络环境和数据安全顾虑。' },
        { icon: 'Code2', title: 'Python 衔接', desc: '从触摸互动平滑过渡到真实 Python 代码，接住未来的信息课。' },
        { icon: 'School', title: '为课堂而做', desc: '老师一键切课，设备临时连不上也能切到键盘模式，课堂不卡壳。' },
      ],
    },
    results: {
      eyebrow: '案例与成果',
      title: '已经在课堂里发生的事',
      stats: [
        { n: '5,000+', l: '课程包服务人次' },
        { n: '50+', l: '合作学校与机构' },
        { n: '98%', l: '合作满意度' },
      ],
      quote: '课程包配套硬件和教案完整，老师上手快，课堂展示效果稳定，机构落地成本明显降低。',
      quoteName: '王女士',
      quoteRole: '合作机构负责人',
    },
    research: {
      eyebrow: '科研背景',
      title: '源自高校科研团队的课程转化',
      desc: '少年造物局由高校机器人与智能控制方向的科研团队孵化，把真实的工程项目和科技馆展示级项目，拆解成学校及机构可落地的项目式课程包。',
      points: [
        { icon: 'FlaskConical', title: '真实项目来源', desc: '课程不是积木拼装，而是摩斯电码密码机、电阻屏画板、板球平衡等真实智能控制项目的课程化改造。' },
        { icon: 'Workflow', title: '清晰转化路径', desc: '从科研原型到课堂教案，沿「输入 → 处理 → 反馈 → 控制」的主线层层拆解，机构教师易理解、易实施。' },
        { icon: 'Package', title: '软硬件一体交付', desc: '硬件套件、示例程序、课件教案、任务卡与源码一并提供，机构开箱即可部署。' },
        { icon: 'TrendingUp', title: '可进阶的体系', desc: '从图形化交互起步，逐步过渡到 Arduino、C++、Python 与闭环控制，支持机构分层实施。' },
      ],
      directions: ['机器人系统', '嵌入式开发', '传感器交互', '智能控制', '视觉识别', '人工智能应用'],
    },
    timeline: {
      eyebrow: '发展历程',
      title: '从一个小程序，到机构课程包',
      desc: '我们一步步把科研项目做成了能交付给机构的课程包与硬件套件。',
      items: [
        { year: '起点', title: '摩斯电码桌面程序', desc: '最初只是一个教摩斯电码的小工具：按住是输入，松手拼成字母，屏幕撒花庆祝。' },
        { year: '第一步', title: '自研电阻屏硬件', desc: '基于 STM32 把小程序装进可离线运行的电阻屏开发板，软硬件一体，稳定能上手。' },
        { year: '扩展', title: '涂鸦板课程上线', desc: '加入电阻屏电子画板，通过 X/Y 坐标绘图任务，展示坐标系与传感器数据的教学路径。' },
        { year: '进阶', title: '板球平衡系统', desc: '把科技馆展示级的闭环控制项目课程化，形成可展示的调参与反馈控制课程内容。' },
        { year: '落地', title: '走进学校与科技馆', desc: '形成硬件 + 课程包 + 师资培训一体化方案，服务信息课、编程社团与科创场景。' },
      ],
    },
    contact: {
      eyebrow: '联系我们',
      title: '想了解机构课程包怎么落地？',
      desc: '如果你来自学校、科技馆、少年宫或培训机构，可以联系我们获取课程包、硬件配置和落地建议。',
    },
  },

  courses: {
    hero: {
      eyebrow: '课程介绍',
      title: '由浅入深的课程包体系',
      desc: '从摩斯电码到自由涂鸦，再到小球平衡，提供难度循序渐进的课程包、课件教案和硬件套件。',
    },
    items: [
      {
        id: 'morse', icon: 'Radio', image: '/images/site/morse-kit-source.png', name: '摩斯电码课程包', level: '入门', age: '机构课程包',
        color: '#2563eb', soft: '#eff6ff', tagline: '按住屏幕，打出第一段密码',
        detail: '这套课程包从最直接的触摸输入开始，配套硬件、课件、教案和示例程序，帮助机构组织编码、时序和反馈相关的项目式课堂。',
        badge: '最受欢迎', learn: ['理解信号与时序', '点划编码与解码', '坚持与专注'],
        stages: {
          primary: '信息科技启蒙：认识信号、把按压长短对应成点和划，再按规则查表解码。',
          middle: '二进制与字符编码（ASCII）思想，条件判断与时序逻辑。',
          high: '通信与编码原理入门，用程序实现自动编解码，衔接算法与数据结构基础。',
        },
      },
      {
        id: 'draw', icon: 'Palette', image: '/images/site/classroom-close.jpg', name: '电阻屏涂鸦板', level: '进阶', age: '机构课程包',
        color: '#7c3aed', soft: '#f5f3ff', tagline: '按到哪，画到哪',
        detail: '涂鸦板把屏幕触摸坐标映射到画布上，配套课程包可用于讲解坐标系、传感器数据和图形交互。',
        badge: '新课上线', learn: ['认识坐标系统', '颜色与笔刷', '动手创作作品'],
        stages: {
          primary: '认识平面位置与方向、(x, y) 坐标，以及颜色的直观概念。',
          middle: '平面直角坐标系、坐标映射与比例、点动成线的图形关系。',
          high: '坐标变换与向量、图形算法与数据可视化思想。',
        },
      },
      {
        id: 'ball', icon: 'CircleDot', image: '/images/products/infrared-ball-balance.png', name: '小球平衡综合套件', level: '高阶', age: '机构课程包',
        color: '#059669', soft: '#ecfdf5', tagline: '神秘电波、电子画画与小球平衡的同一套课程线',
        detail: '神秘电波和电子画画都归入小球平衡综合套件：先用触摸输入理解信号与坐标，再过渡到红外遥控控制、传感器反馈和板球平衡的闭环调节。',
        badge: '核心产品', learn: ['神秘电波', '电子画画', '红外遥控', '闭环控制'],
        stages: {
          primary: '直观感受平衡与力，建立"观察—调整"的因果关系。',
          middle: '加入红外遥控与坐标映射，理解指令、变量变化和控制结果之间的关系。',
          high: '闭环控制（PID 思想）、传感器数据处理，物理与算法结合。',
        },
      },
    ],
  },

  about: {
    hero: { eyebrow: '关于我们', title: '我们从一个小程序开始' },
    story: [
      '最开始，少年造物局只是一个教摩斯电码的桌面小程序。一块电阻屏，按住是输入，松手拼成字母，屏幕上撒花庆祝。我们本来只想做个课堂小工具。',
      '在机构试用和课堂验证中，这套硬件有明确的展示效果和互动反馈。于是我们把它扩展成可交付的硬件套件、课件教案和课程包。',
      '课程包会持续迭代，但出发点一直没变：让机构能用真实硬件组织可展示、可操作的编程与科创项目。',
    ],
    values: {
      title: '我们相信什么',
      items: [
        { icon: 'Wrench', title: '先动手，再讲道理', desc: '不堆术语，用硬件任务和课件流程帮助机构教师组织项目式课堂。' },
        { icon: 'Heart', title: '做机构好交付的产品', desc: '撒花、声音、积分，每一次正确输入都有即时的正反馈。' },
        { icon: 'Cpu', title: '硬件自己做', desc: '基于 STM32 自研开发板，稳定、可离线、能二次开发。' },
      ],
    },
    team: {
      title: '做这件事的人',
      subtitle: '一支不大但较真的小团队（下面是花名）。',
      members: [
        { name: '阿码', role: '硬件 & 固件', desc: '把摩斯电码小程序装进电阻屏开发板的人，负责设备稳定能上手。', color: '#2563eb', image: '' },
        { name: '小芽', role: '课程教研', desc: '课程教研成员把零散功能整理成机构教师讲得顺、可复制实施的课。', color: '#7c3aed', image: '' },
        { name: '点点', role: '产品 & 交互', desc: '关注交互反馈、设备手感和课堂稳定性，让机构交付更顺畅。', color: '#059669', image: '' },
      ],
    },
  },

  schools: {
    hero: {
      eyebrow: '学校合作',
      title: '把动手编程课，搬进课堂',
      desc: '面向学校、少年宫、科技馆和培训机构，我们提供硬件、课程包、师资培训和技术支持一体化方案。',
    },
    offers: {
      title: '我们提供什么',
      items: [
        { icon: 'Package', title: '整套硬件设备', desc: '电阻屏开发板 + 配套连接模块，开箱即用，按班级数量配置。' },
        { icon: 'BookOpen', title: '现成课程包', desc: '配套课件、课堂流程和练习，老师拿来就能上，不用从零备课。' },
        { icon: 'GraduationCap', title: '师资培训支持', desc: '提供面向机构教师的上手培训、交付说明和课堂组织建议。' },
        { icon: 'Wrench', title: '技术支持', desc: '设备维护与固件更新支持，用起来出问题随时找我们。' },
        { icon: 'WifiOff', title: '离线部署', desc: '无需校园网络，不依赖外网，符合校园对数据安全的要求。' },
        { icon: 'RefreshCw', title: '课程持续更新', desc: '统一课程平台会持续加入新课程，老课程也会迭代优化。' },
      ],
    },
    steps: {
      title: '三步开始合作',
      items: [
        { title: '联系沟通', desc: '告诉我们学校规模和需求，我们给出配置建议。' },
        { title: '试用体验', desc: '安排一次产品与课程包演示，确认机构场景、设备数量和交付方式。' },
        { title: '部署落地', desc: '配齐设备、完成师资培训支持，课程正式进入课表。' },
      ],
    },
  },

  contactPage: {
    hero: {
      eyebrow: '联系我们',
      title: '获取机构合作方案',
      desc: '留下联系方式，我们会在 24 小时内联系你安排时间。',
    },
    faqs: [
      { q: '机构部署需要网络吗？', a: '不需要。设备可离线运行，适合学校和机构在不同网络环境下部署。' },
      { q: '机构教师没有很强编程背景可以用吗？', a: '可以。课程包包含课件、教案、示例程序和操作流程，方便机构教师快速上手。' },
      { q: '适合哪些机构场景？', a: '适合学校信息课、科创社团、科技馆、少年宫及编程/机器人培训机构。' },
      { q: '可以先了解方案吗？', a: '可以。留下机构信息和应用场景，我们会提供课程包与硬件配置建议。' },
    ],
  },
};

export default defaultContent;